import React, { Component } from "react";

export class Services extends Component {
    render() {
        return (
            <div id="services" className="text-center">
                <div className="container">
                    <div className="section-title">
                        <h2>Our Services</h2>
                        <p>
                            We offer a wide range of services. We want to help you tell your
                            story so that your customers/audience know they are in good hands. If
                            you are not sure how we can help you, please be sure to contact us!
                        </p>
                    </div>
                    <div className="row">
                        {this.props.data
                            ? this.props.data.map((d, i) => (
                                <div  key={`${d.name}-${i}`} className="col-md-6">
                                    {" "}
                                    <i className={d.icon}></i>
                                    <div className="service-desc">
                                        <h3>{d.name}</h3>
                                        <p>{d.text}</p>
                                    </div>
                                </div>
                            ))
                            : "loading"}
                    </div>
                    <div className="section-call-to-action">
                        <a
                            href="#contact"
                            className="btn btn-custom btn-lg page-scroll"
                        >
                            Contact Us
                        </a>{" "}
                    </div>
                </div>
            </div>
        );
    }
}

export default Services;